var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.716,17.51H36.284c-3.06,0-5.55,2.49-5.55,5.55v49.879c0,3.061,2.49,5.55,5.55,5.55h23.432 c3.061,0,5.551-2.489,5.551-5.55V23.061C65.267,20,62.776,17.51,59.716,17.51z M36.284,21.51h23.432 c0.855,0,1.551,0.695,1.551,1.55v40.374H34.734V23.061C34.734,22.206,35.429,21.51,36.284,21.51z M59.716,74.489H36.284 c-0.854,0-1.55-0.695-1.55-1.55v-5.505h26.533v5.505C61.267,73.794,60.571,74.489,59.716,74.489z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,68.361c-1.464,0-2.655,1.191-2.655,2.655c0,1.464,1.191,2.655,2.655,2.655s2.655-1.191,2.655-2.655 C50.655,69.552,49.464,68.361,48,68.361z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone2);
export default __webpack_public_path__ + "static/media/phone-2.c4c70650d71977a572e37fb19b43feaa.svg";
export { ForwardRef as ReactComponent };